import { LoadingItemTemplate } from './loading-item-template';
import { RecurrencyPattern } from './recurrency-pattern';

export class LoadingTemplate {
  id: number = 0;
  loadlocationID: number;
  info: string;
  info2: string;
  loadingType: number;
  loadingType2: number;
  companyID: number;
  extNr1: string;
  extNr2: string;
  loadingDateFrom: string;
  loadingDateTo: string;
  precommissioned: boolean;
  loadingItemTemplates: LoadingItemTemplate[] = [];
  recurrencyPattern: RecurrencyPattern;
  recurrencyPatternID: number;
  disabled: boolean = false;

  static fromLoading(loading) {
    let loadingTemplate = new LoadingTemplate();
    Object.assign(loadingTemplate, {
      id: 0,
      disabled: false,
      loadlocationID: loading.loadlocationID,
      info: loading.info,
      info2: loading.info2,
      loadingType: loading.loadingType,
      loadingType2: loading.loadingType2,
      companyID: loading.companyID,
      extNr1: loading.extNr1,
      extNr2: loading.extNr2,
      loadingDateFrom: loading.loadingDateFrom,
      loadingDateTo: loading.loadingDateTo,
      precommissioned: loading.precommissioned,
      recurrencyPattern: null,
      loadingItemTemplates: Array.isArray(loading.loadingItems) ? loading.loadingItems.map(li => LoadingItemTemplate.fromLoadingItem(li)) : []
    });
    return loadingTemplate;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/models/loading-template.ts